import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../../_actions/loader.actions';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomColumn from '../../../../customControl/CustomColumn';
import { formatDateyearmonthday } from '../../../commonClass/CommonValidation';
import dayjs from 'dayjs';
import ActivityBulkUpdateModal from './partial/ActivityBulkUpdateModal';
import { activityRateInventoryClose } from '../../../../_actions/user.action';

const ActivityInventory = (
    { ActivityName,
        ActivityBasicInfoId,
        disabled,
        dropdownData
    }) => {
    const dispatch = useDispatch()
    const isUpdate = useSelector(store => store?.activityrateInventory?.isUpdate)
    const BulkUpdateDrodownList = [
        // { id: 1, name: 'Inventory', alias: 'Bulk Inventory' },
        { id: 2, name: 'Rates', alias: 'Bulk Rates' },
        // { id: 3, name: 'Blackout', alias: 'Blackout' }
    ]

    const [formValue, setFormValue] = useState({
        ActivityBasicInfoId: 0,
        SelecteDate: null,
        UserId: 0,
    })

    const [paxTypeList, setPaxTypeList] = useState([])
    const [dropDownList, setDropDownList] = useState([])
    const [selectedactivity, setSelectedactivity] = useState(null)
    const [availabilityDates, setAvailabilityDates] = useState({
        StartDate: '',
        EndDate: ''
    })

    // set end date for calander (actual room's end date - 4)
    const lastRequiredDate = new Date(new Date(selectedactivity?.basicData?.[0]?.ValidityToDate).setDate(new Date(selectedactivity?.basicData?.[0]?.ValidityToDate).getDate() - 4))

    const [modalTitle, setModalTitle] = useState("")
    const [openModal, setOpenModal] = useState(false)
    const [modalTypeEdit, setModalTypeEdit] = useState(false)
    const [selectedCellDate, setSelectedCellDate] = useState(null)

    const [startDate, setStartDate] = useState(moment().startOf('day'));
    const [activityInventory, setActivityInventory] = useState([])

    //#region Days Range List API
    const getactivityinventoryotherinfo = async (id) => {
        const activityinventoryinof = await getAllData(`/master/v1/getactivityinventoryotherinfo?ActivityBasicInfoId=${id}`)
        if (activityinventoryinof?.status) {
            setPaxTypeList(activityinventoryinof?.data?.paxTypeList)
            setSelectedactivity(activityinventoryinof?.data)
            setDropDownList(activityinventoryinof?.data)
            let ActivityStartDate = setStartDateOfTable(activityinventoryinof?.data?.basicData?.[0]?.ValidityFromDate, activityinventoryinof?.data?.basicData?.[0]?.ValidityToDate)
            setStartDate(ActivityStartDate)
        }
    }
    //#endregion

    //#region Rate and Inventory Values API
    const getactivitymanageinventory = async (data) => {
        const activityinventory = await postUsersData('/master/v1/getactivitymanageinventory', data)
        if (activityinventory?.status) {
            setActivityInventory(
                activityinventory?.data?.map((el) => ({
                    ...el,
                    PaxWiseSlotsWithPrice: JSON?.parse(el?.PaxWiseSlotsWithPrice) ?? null
                }))
            );
            dispatch(activityRateInventoryClose())
        }
    }
    //#endregion

    //#region set Selected Activity Availability Dates and call Rate and Inventory API function
    useEffect(() => {
        async function fetchData(data) {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                try {
                    dispatch(loaderActions.start())
                    getactivitymanageinventory(data)
                } catch (error) {
                    console.error(`Error fetching data: ${error}`)
                } finally {
                    dispatch(loaderActions.end())
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end())
            }
        }
        if (selectedactivity) {
            setAvailabilityDates((activity) => ({ ...activity, StartDate: selectedactivity?.basicData?.[0]?.ValidityFromDate, EndDate: selectedactivity?.basicData?.[0]?.ValidityToDate }))
            let data = {
                ActivityBasicInfoId: ActivityBasicInfoId,
                FromDate: `${formatDateyearmonthday(startDate)}T00:00:00`,
                ToDate: `${formatDateyearmonthday(startDate.clone().add(4, 'days'))}T00:00:00`,
            }
            fetchData(data)
        }
    }, [selectedactivity, startDate])
    //#endregion

    //#region call Rate and Inventory API function when Inventory or Rate updated through pop-up
    useEffect(() => {
        if (isUpdate) {
            let data = {
                ActivityBasicInfoId: ActivityBasicInfoId,
                FromDate: `${formatDateyearmonthday(startDate)}T00:00:00`,
                ToDate: `${formatDateyearmonthday(startDate.clone().add(4, 'days'))}T00:00:00`,
            }
            dispatch(loaderActions.start())
            getactivitymanageinventory(data)?.then(() => dispatch(loaderActions.end()))
        }
    }, [isUpdate])
    //#endregion

    //#region call Activity Dropdown value List API
    useEffect(() => {

        async function fetchData() {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage()
                setFormValue((form) => ({ ...form, ActivityBasicInfoId: ActivityBasicInfoId, UserId: user?.userMasterID }))
                try {
                    dispatch(loaderActions.start())
                    await Promise.all([
                        getactivityinventoryotherinfo(ActivityBasicInfoId)
                    ])

                } catch (error) {
                    console.error(`Error fetching data: ${error}`)
                } finally {
                    dispatch(loaderActions.end())
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end())
            }

        }
        fetchData()
    }, [])
    //#endregion

    //#region Select Date On Change
    const handleSelectDate = (update) => {
        setFormValue(form => ({ ...form, SelecteDate: update }))
        setStartDate(moment(update))
    }
    //#endregion

    //#region Date Icon click function
    const openDatePicker = (e) => {
        //open date picker on click date icon 
        document.querySelector("#" + e).click();
    };
    //#endregion

    //#region Table Start Date depends on room
    const setStartDateOfTable = (startdate, enddate) => {
        return moment().startOf('day') <= new Date(startdate) ?
            moment(new Date(startdate))
            :
            moment().startOf('day') >= moment(new Date(enddate)).clone().subtract(4, 'days') ?
                moment(new Date(enddate)).clone().subtract(4, 'days')
                :
                moment().startOf('day')
    }
    //#endregion

    //#region Table Calander Previous button
    const goToPreviousWeek = (e) => {
        e.preventDefault()
        if (startDate.clone().subtract(5, 'days') <= new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)) {
            setStartDate(moment(new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)));
        }
        else {
            setStartDate(startDate.clone().subtract(5, 'days'));
        }
    };
    //#endregion

    //#region Table Calander Next button
    const goToNextWeek = (e) => {
        e.preventDefault()
        if (startDate.clone().add(9, 'days') > new Date(selectedactivity?.basicData?.[0]?.ValidityToDate)) {
            setStartDate(moment(lastRequiredDate));
        }
        else {
            setStartDate(startDate.clone().add(5, 'days'));
        }
    };
    //#endregion

    //#region Table Calander (Dates)
    const renderCalendar = () => {
        const days = [];
        let currentDate = startDate.clone();

        for (let i = 0; i < 5; i++) {
            days.push(
                <th key={currentDate.format('YYYY-MM-DD')}>
                    {
                        // eslint-disable-next-line no-loop-func
                        (() => {
                            if (i === 0) {
                                return (
                                    <div className="position-relative">
                                        <button
                                            className="slideButton slidePrev"
                                            id="slidePrev"
                                            type="button"
                                            disabled={startDate <= new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)}
                                            onClick={(e) => goToPreviousWeek(e)}
                                        >
                                            <img src={require("../../../../assets/img/expand_more.png")} alt="prev" />
                                        </button>
                                        <div className="date-and-day">
                                            <div className="text-nowrap header_date">{Number(currentDate.format('D')) > 9 ? currentDate.format('D') : '0' + currentDate.format('D')}-{currentDate.format('MMM')}-{currentDate.format('YYYY')}</div>
                                            <div className="header_day">{currentDate.format('dddd')}</div>
                                        </div>
                                    </div>
                                )
                            }
                            else if (i === 4) {
                                return (
                                    <div className="position-relative">
                                        <div className="date-and-day">
                                            <div className="text-nowrap header_date">{Number(currentDate.format('D')) > 9 ? currentDate.format('D') : '0' + currentDate.format('D')}-{currentDate.format('MMM')}-{currentDate.format('YYYY')}</div>
                                            <div className="header_day">{currentDate.format('dddd')}</div>
                                        </div>
                                        <button
                                            className="slideButton slideNext"
                                            id="slideNext"
                                            type="button"
                                            disabled={startDate.clone().add(4, 'days') >= new Date(selectedactivity?.basicData?.[0]?.ValidityToDate)}
                                            onClick={(e) => goToNextWeek(e)}
                                        >
                                            <img src={require("../../../../assets/img/expand_more.png")} alt="next" />
                                        </button>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div className="date-and-day">
                                        <div className="text-nowrap header_date">{Number(currentDate.format('D')) > 9 ? currentDate.format('D') : '0' + currentDate.format('D')}-{currentDate.format('MMM')}-{currentDate.format('YYYY')}</div>
                                        <div className="header_day">{currentDate.format('dddd')}</div>
                                    </div>
                                )
                            }
                        })()
                    }

                </th>

            );
            currentDate = currentDate.clone().add(1, 'day');
        }
        return days;
    };
    //#endregion

    //#region set values on rate and inventory charts
    const renderCalendarInventoryStatic = (name, type, paxTypeId, ActivitySlotId) => {
        const days = [];

        for (let i = 0; i < 5; i++) {
            const dateStr = startDate.clone().add(i, "day").format("YYYY-MM-DD");

            const item = activityInventory?.find(
                (inv) => inv?.ActivityInvDate === `${dateStr}T00:00:00`
            );

            if (!item) {
                days.push(
                    <td key={`${name}_${dateStr}`} className="inventory_disable">
                        <div className="common-input">Not Available</div>
                    </td>
                );
                continue;
            }

            let value;

            if (type === "Inventory") {
                value = item[name];
            }
            else {
                const pax = item?.PaxWiseSlotsWithPrice?.find(
                    (fil) => fil.PaxTypeId === paxTypeId
                );

                if (ActivitySlotId) {
                    const slot = pax?.Slots?.find(
                        (val) => val?.ActivityManageActivitySlotId === ActivitySlotId
                    );

                    value = slot?.[name] > 0 ? slot?.[name] : "Not Available";
                } else {
                    value = pax?.[name];
                }
            }

            days.push(
                <td key={`${name}_${dateStr}`} className="inventory_disable">
                    <div className="common-input">
                        {value ?? "Not Available"}
                    </div>
                </td>
            );
        }

        return days;
    };

    //#endregion

    //#region handle Bulk Update Modals
    const handleModal = (name) => {
        setModalTitle(name)
        setOpenModal(true)
        setModalTypeEdit(false)
        setSelectedCellDate(null)
    }
    //#endregion

    //#region handle Edit Modals
    const handleEdit = (e, name, cellDate) => {
        e.preventDefault()
        setModalTitle(name)
        setOpenModal(true)
        setModalTypeEdit(true)
        setSelectedCellDate(cellDate)
    }
    //#endregion

    return (
        <div className="my-5">
            <div className="container-fluid form_border my-2 py-3 activity_inventory_DatePicker">
                <>
                    {
                        openModal &&
                        <ActivityBulkUpdateModal
                            open={openModal}
                            title={modalTitle}
                            isEdit={modalTypeEdit}
                            selectedCellDate={selectedCellDate}
                            availabilityDates={availabilityDates}
                            setOpenModal={setOpenModal}
                            activityInventory={activityInventory}
                            dropDownList={dropDownList}
                            ActivityBasicInfoId={formValue.ActivityBasicInfoId}
                            ActivityName={ActivityName}
                            UserId={formValue.UserId}
                            dropdownData={dropdownData}
                        />
                    }
                    <div className="container-fluid mt-2 heading_color input_mui">
                        {
                            selectedactivity ?
                                <div className="d-flex justify-content-end align-items-center mb-4 mt-3" key="bulk-update-en">
                                    <div
                                        id="bulk_update_id"
                                        role="button"
                                        className="me-2 dropdown-toggle bulk_update_btn px-3 my-1 text-danger border-start"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        disabled={disabled}
                                    >
                                        Bulk Update
                                    </div>
                                    <div className="dropdown-menu dropdown-menu-end ms-4 dropdown_zindexset bulkupdate_dropdown" aria-labelledby="bulk_update_id">
                                        <div className="bulk_dropdown">
                                            {
                                                BulkUpdateDrodownList?.map(element => {
                                                    return (
                                                        <div key={element.id} className="bulk_dropdown_item" role='button' onClick={() => handleModal(element)}>
                                                            {element.name}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="d-flex justify-content-end align-items-center mb-4 mt-3" key="bulk-update-dis">
                                    <div disabled={disabled} className="me-2 bulk_update_btn px-3 my-1 text-danger border-start"> Bulk Update </div>
                                </div>
                        }

                        <div className="row rate_invenroty_searching mb-4">
                            <CustomColumn labelText='Activity Name' labelId='ActivityNameid'>
                                <input
                                    type="text"
                                    className='form-control'
                                    name="ActivityName"
                                    id="ActivityName"
                                    disabled
                                    value={ActivityName}
                                    placeholder='ActivityName'
                                    readOnly
                                />
                            </CustomColumn>
                            <CustomColumn labelText='Select Date' labelId='inventoryselectdate' >
                                <div className='position-relative'>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        className={`form-control ${disabled ? '' : 'bg-body'}`}
                                        id='inventoryselectdaterange'
                                        selected={formValue.SelecteDate}
                                        placeholderText="Select Date"
                                        autoComplete='off'
                                        showMonthDropdown
                                        onChange={(e) => handleSelectDate(e)}
                                        minDate={new Date(selectedactivity?.basicData?.[0]?.ValidityFromDate)}
                                        maxDate={lastRequiredDate}
                                        showYearDropdown
                                        disabled={disabled}
                                        dropdownMode='select'
                                        onFocus={(e) => e.target.readOnly = true}
                                    />
                                    <span className="example-custom-input activityinventoryBtn"
                                        onClick={(e) => openDatePicker("inventoryselectdaterange")}
                                    ><i className="fa fa-calendar"></i></span>
                                </div>
                            </CustomColumn>
                        </div>
                        <div className="table_hotel_individual_rates_inventory hotel_master">
                            <div className="hotel_individual_rates_inventory">
                                <table className="rates-inventory-table-calender">
                                    <thead>
                                        <tr>
                                            <th className="rates_inventory_header_title">
                                                <h6 className='fw-bold'>Dates</h6>
                                            </th>
                                            {renderCalendar()}
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>


                            <div className="accordion hotel_rate_inventory" id='accordionRoom2'>

                                <div className="accordion-item">
                                    <div
                                        className="inventory-room-name accordion-button collapsed position-relative"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#activity-${ActivityBasicInfoId}`}
                                        aria-expanded="false"
                                        aria-controls={`activity-${ActivityBasicInfoId}`}
                                    >
                                        {ActivityName}
                                        <div className="room_count">{selectedactivity?.basicData?.[0]?.Inventory}</div>
                                    </div>
                                    <div
                                        id={`activity-${ActivityBasicInfoId}`}
                                        className="accordion-collapse collapse"
                                    >
                                        <div className="accordion inventory_data" id={`${ActivityBasicInfoId}`}>
                                            <div className="accordion-item">
                                                <div className="position-relative">
                                                    <button
                                                        // disabled={disabled}
                                                        disabled={true}
                                                        type="button"
                                                        className="btn btn-primary mx-1 rounded-pill save_btn edit_option"
                                                        onClick={(e) => handleEdit(e, { id: 1, name: 'Inventory', alias: 'Inventory' }, null)}>Edit</button>
                                                    <div
                                                        className="inventory-room-name-data accordion-button collapsed position-relative"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={'#deluxInventory'}
                                                        aria-expanded="false"
                                                        aria-controls={'deluxInventory'}
                                                    >
                                                        Inventory (Units)
                                                        <div className="etm_room_count">{selectedactivity?.basicData?.[0]?.Inventory} </div>
                                                    </div>
                                                    <div
                                                        id={'deluxInventory'}
                                                        className="accordion-collapse collapse"
                                                    >
                                                        <table className="rates-inventory-table">
                                                            <thead>
                                                                <tr>
                                                                    <th className="rates_inventory_header_title"></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="text-start">
                                                                        <label>Available</label>
                                                                    </td>
                                                                    {renderCalendarInventoryStatic('InventoryStock', 'Inventory')}
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-start">
                                                                        <label>On Hold</label>
                                                                    </td>
                                                                    {renderCalendarInventoryStatic('BlackOut', 'Inventory')}
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-start">
                                                                        <label className="text-right">Sold</label>
                                                                    </td>
                                                                    {renderCalendarInventoryStatic('SoldOut', 'Inventory')}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item">
                                                <div className="position-relative">
                                                    <button type="button" disabled={disabled} className="btn btn-primary mx-1 rounded-pill save_btn edit_option" onClick={(e) => handleEdit(e, { id: 2, name: 'Rates', alias: 'Rates' }, null)}>Edit</button>

                                                    <div
                                                        className="inventory-room-name-data accordion-button collapsed position-relative"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={'#deluxRates'}
                                                        aria-expanded="false"
                                                        aria-controls={'deluxRates'}
                                                    >
                                                        Rates (₹)
                                                    </div>
                                                    <div
                                                        id={'deluxRates'}
                                                        className="accordion-collapse collapse"
                                                    >
                                                        <table className="rates-inventory-table">
                                                            <thead>
                                                                <tr>
                                                                    <th colSpan={2} className="rates_inventory_header_title"></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>

                                                            {
                                                                paxTypeList?.map((el, index) => {
                                                                    return (
                                                                        <tbody key={el?.PaxTypeId + index} className='colspan_2'>
                                                                            <tr>
                                                                                <td rowSpan={selectedactivity?.basicData?.[0]?.IsScheduleActivity ? activityInventory?.[0]?.PaxWiseSlotsWithPrice?.find((ele) => ele.PaxTypeId === el?.PaxTypeId)?.Slots?.length + 1 : 2} className='col_1 text-start'>
                                                                                    <label>{el?.LabelName}</label>
                                                                                </td>
                                                                            </tr>
                                                                            {selectedactivity?.basicData?.[0]?.IsScheduleActivity ?
                                                                                activityInventory?.[0]?.PaxWiseSlotsWithPrice?.find((ele) => ele.PaxTypeId === el?.PaxTypeId)?.Slots?.map((obj) =>
                                                                                    <tr>
                                                                                        <td className="text-start col_2">
                                                                                            <label>{dayjs(obj?.StartTime, "HH:mm:ss")?.format("hh:mm A")}&nbsp;TO&nbsp;{dayjs(obj?.EndTime, "HH:mm:ss")?.format("hh:mm A")}</label>
                                                                                        </td>
                                                                                        {renderCalendarInventoryStatic('DisplayPrice', 'Rates', el?.PaxTypeId, obj.ActivityManageActivitySlotId)}
                                                                                    </tr>
                                                                                )
                                                                                :
                                                                                <tr>
                                                                                    <td className="text-start col_2">
                                                                                        <label>{selectedactivity?.basicData?.[0]?.ScheduleActivityMessage}</label>
                                                                                    </td>
                                                                                    {renderCalendarInventoryStatic('DisplayPrice', 'Rates', el?.PaxTypeId, null)}
                                                                                </tr>
                                                                            }
                                                                        </tbody>
                                                                    )
                                                                })
                                                            }
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </div>
        </div>
    )
}

export default ActivityInventory